(function(){
  const section = document.querySelector('[data-microfiber-story]');
  if(!section || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const images = Array.from(section.querySelectorAll('.microfiber-story-image'));
  const cta = section.querySelector('[data-microfiber-cta]');
  if(images.length < 2) return;

  let activeIndex = -1;
  function setCTA(index){
    if(!cta || !images[index] || index === activeIndex) return;
    activeIndex = index;
    cta.textContent = images[index].dataset.buyLabel || 'Buy now';
    cta.href = images[index].dataset.buyUrl || '#';
  }

  function syncCTAWithVisibleImage(){
    let topIndex = 0;
    let topAlpha = -1;
    images.forEach((img, idx) => {
      const alpha = Number(gsap.getProperty(img, 'autoAlpha'));
      if(alpha > topAlpha){
        topAlpha = alpha;
        topIndex = idx;
      }
    });
    setCTA(topIndex);
  }

  gsap.set(images, {autoAlpha:0, scale:1, rotation:0, yPercent:0, filter:'drop-shadow(0 30px 60px rgba(0,0,0,.35))'});
  gsap.set(images[0], {autoAlpha:1});
  setCTA(0);

  const tl = gsap.timeline({
    defaults:{ease:'power2.inOut'},
    scrollTrigger:{
      trigger: section,
      start:'top top',
      end:'bottom bottom',
      scrub:0.6,
      onUpdate: syncCTAWithVisibleImage
    }
  });

  for(let i=0;i<images.length-1;i++){
    const current = images[i];
    const next = images[i+1];

    tl.to(current, {duration:0.9, autoAlpha:0, scale:0.92, rotation:i % 2 === 0 ? -8 : 8, yPercent:14, filter:'drop-shadow(0 20px 40px rgba(0,0,0,.26))'});

    tl.fromTo(next,
      {autoAlpha:0, scale:1.06, rotation:i % 2 === 0 ? 7 : -7, yPercent:-6, filter:'drop-shadow(0 20px 40px rgba(0,0,0,.26))'},
      {duration:0.9, autoAlpha:1, scale:1, rotation:0, yPercent:0, filter:'drop-shadow(0 30px 60px rgba(0,0,0,.35))'},
      '<0.15'
    );
  }

  tl.to(images[images.length-1], {duration:0.5, scale:1.03, yoyo:true, repeat:1, ease:'sine.inOut'});
})();
